<template>
  <v-container
    id="login"
    class="justify-center mt-10 mt-sm-0 pt-3 pt-sm-0 pb-3 pb-sm-0"
    tag="section"
    :fluid="$vuetify.breakpoint.name != 'xl' && $vuetify.breakpoint.name != 'lg'"
  >
    <v-row justify="center">
      <v-col lg="12" md="12" sm="12" xl="7" class="pl-2 pr-2 pt-0 pb-0">
        <v-card class="elevation-4 pl-2 pr-2">
          <v-row>
            <v-col lg="5" md="5" class="d-none d-md-flex pa-0 full-height left-panel">
              <div></div>
            </v-col>
            <v-col lg="7" md="7" class="pl-md-10">
              <div class="d-none d-sm-flex mt-10 mb-16 flex-lg-nowrap flex-sm-wrap">
                <!-- <PaCELogo /> -->
                <img class="logo" src="@/assets/PACE_low-fi.jpg" />
                <a class="black--text ml-auto mr-3 mt-3 signin-link text-right" v-if="user">
                  <span><small>{{ userInfo }}</small></span> <br/>
                  <span class="v-underline" @click="logout">Sign out ></span>
                </a>
                <a
                  @click="login"
                  class="v-underline ml-auto mr-3 black--text signin-link"
                  v-else
                >Sign in ></a>
              </div>
              <div v-if="tab == 1">
                <p class="statement text-wrap">What are you looking for today?</p>
                <!-- <h4 class="tab-title mt-4">Resources for:</h4> -->
                
                <div class="mt-4">
                  
                  <!-- <div v-if="viewMode === 'donut'" id="67e0f2339bc4cd7cb7c1f9cf" class="genially-embed" style="margin: 0px auto; position: relative; height: auto; width: 100%;"></div> -->

                  
                  <!-- Donut View -->
                  <CapabilityDonut
                      v-if="viewMode === 'donut'"
                      :value="selectedTicklistItems"
                      :groups="groups"
                      :items="items"
                      hub-title="Palliative Care Capabilities"
                      hub-sub="People with palliative care needs"
                      :outer-radius="460"
                      :inner-radius="230"
                      :group-band="90"
                      :gap-degrees="4"
                      :start-angle="-110"
                      @select="onDonutSelect"
                  />

                                  <!-- Toggle between donut and ticklist views -->
                <div class="view-toggle mt-3 mb-4">
                  <v-btn-toggle v-model="viewMode" mandatory color="primary">
                    <v-btn small value="donut">
                      <v-icon left small>mdi-chart-donut</v-icon>
                      Interactive View
                    </v-btn>
                    <v-btn small value="ticklist">
                      <v-icon left small>mdi-format-list-checks</v-icon>
                      List View
                    </v-btn>
                  </v-btn-toggle>
                </div>
                  
                  <!-- Ticklist View -->
                  <CapabilityTicklist
                      v-if="viewMode === 'ticklist'"
                      :value="selectedTicklistItems"
                      :items="items"
                      hub-title="Palliative Care Capabilities"
                      hub-subtitle="Select the capabilities you want to develop"
                      @change="onTicklistChange"
                      :show-selection-summary="false"
                  />
                  
                  <!-- Single Shared Selection Summary Component -->
                  <SelectionSummary
                    :selected-items="selectedTicklistItems"
                    :all-items="items"
                    @continue-clicked="goToSearch(false)"
                  />
                  
                  <!-- <v-list>
                    <v-list-item-group v-model="selectedResource" mandatory color="pace_grey">
                      <v-list-item
                        v-for="(item, i) in resourcesForItems"
                        :key="i"
                        @click="selectResource(i)"
                      >
                        <v-list-item-avatar size="65">
                          <span class="white--text headline">{{ item.short }}</span>
                        </v-list-item-avatar>

                        <v-list-item-content class="my-auto">
                          <p class="text">{{item.name}}</p>
                          <span class="subtext">{{item.subtext}}</span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list> -->
                </div>



                <div class="d-block d-sm-flex align-center mb-4 ml-4">
                  <div>
                    <span class="mr-3">None of above?</span>
                    <a @click="goToSearch(true)" class="link">Skip to search</a>
                  </div>
                </div>
              </div>
              <div v-else>
                <h4 class="tab-title mt-4">Which capabilities would you like to develop?</h4>
                <p>Your selection will be highlighted in yellow, tap to deselect.</p>
                <div class="mt-4">
                  <!-- <v-list>
                    <v-list-item-group
                      v-model="selectedCapabilities"
                      multiple
                      mandatory
                      color="pace_grey"
                    >
                      <v-list-item
                        v-for="(item, i) in capabilityCodes[selectedResource].items"
                        :key="i"
                      >
                        <v-list-item-avatar size="65">
                          <span
                            class="white--text headline"
                          >{{ capabilityCodes[selectedResource].short }}{{i + 1}}</span>
                        </v-list-item-avatar>

                        <v-list-item-content class="my-auto">
                          <p class="subtext mb-0">{{item.description}}</p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list> -->




                  <div v-if="picked !== null && items[picked]" class="mt-3">
                    Selected: {{ items[picked].label }} (group: {{ groups[items[picked].group] && groups[items[picked].group].name }})
                  </div>

                </div>
                <div class="d-block d-sm-flex align-center mb-4 mt-4">
                  <v-btn class="ml-3 mr-3" text @click="tab = 1"> <v-icon>mdi-arrow-left</v-icon> back </v-btn>
                  <div class="text-right">
                    <span
                      class="selected-count mr-2"
                    >View {{selectedTicklistItems && selectedTicklistItems.length}} of {{capabilityCodes.items && capabilityCodes.items.length}} selected</span>
                    <v-btn color="bg-pace-yellow" fab small @click="goToSearch(false)">
                      <v-icon color="white">mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div>
                  
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { capabilityCodes } from "@/data/capabilitycodes";
import { mapGetters, mapActions } from "vuex";
import userInfoDisplayMixin from "@/mixins/userInfoDisplayMixin";
import CapabilityDonut from "@/components/CapabilityDonut.vue";
import CapabilityTicklist from "@/components/CapabilityTicklist.vue";
import SelectionSummary from "@/components/SelectionSummary.vue";
import PaCELogo from '@/components/pace-logo.vue'

export default {
  name: "Greeting",

  mixins: [userInfoDisplayMixin],

  data: () => ({
    tab: 1,
    selectedResource: null,
    selectedCapabilities: null,
    capabilityCodes: capabilityCodes,
    viewMode: 'donut', // Toggle between 'donut' and 'ticklist'
    selectedTicklistItems: [], // Array of selected capability indices
    // Add these to data so you can pass them as props to CapabilityDonut
    groups: [
      { name:'Knowing', color:'#7A3C9A', textColor:'#fff', flip: false },
      { name:'Being',   color:'#3DB09E', textColor:'#fff', flip: false },
      { name:'Doing',   color:'#3F95C8', textColor:'#fff', flip: true },
    ],
    items: [
     { 
        label: 'Principles & Values', 
        code: 'K1',
        fullStatement: 'Understand the principles and values of palliative care.',
        group: 0,
        index: 0
      },
      { 
        label: 'Unique Responses', 
        code: 'K2',
        fullStatement: 'Understand the unique responses of individuals, families and communities to life-limiting conditions, dying and death.',
        group: 0,
        index: 1
      },
       { 
        label: 'Communication', 
        code: 'D1',
        fullStatement: 'Use person and family-centred communication in the context of palliative care.',
        group: 2,
        index: 2
      },
      { 
        label: 'Inclusive Care', 
        code: 'D2',
        fullStatement: 'Provide inclusive and culturally safe care for people affected by life-limiting conditions.',
        group: 2,
        index: 3
      },
      { 
        label: 'Collaborative Care', 
        code: 'D3',
        fullStatement: 'Provide collaborative and person-centred care to optimise quality of life for people with life-limiting conditions.',
        group: 2,
        index: 4
      },
      { 
        label: 'Legislation & Frameworks', 
        code: 'B1',
        fullStatement: 'Respect ethical frameworks and legislation that support palliative care practice.',
        group: 1,
        index: 5
      },
      { 
        label: 'Ongoing Development', 
        code: 'B2',
        fullStatement: 'Participate in activities to develop self and services in the provision of palliative care.',
        group: 1,
        index: 6
      },

    ],
    picked: null
  }),

  components: { CapabilityDonut, CapabilityTicklist, SelectionSummary,
    // PaCELogo 
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    
    resourcesForItems() {
      return capabilityCodes.map((item, index) => {
        return {
          name: item.name,
          short: item.short,
          id: item.id,
          subtext: `${item.items.length} capabilities`
        };
      });
    },
    
    selectedCapabilityLabels() {
      return this.selectedTicklistItems.map(index => this.items[index]?.label).filter(Boolean);
    }
  },

  methods: {
    ...mapActions(['toggleAuthModal']),
    selectResource(index) {
      this.selectedResource = index;
      this.selectedCapabilities = null;
      this.tab = 2;
    },
    handleSelect({ index, item }) {
      console.log('Selected slice:', index, item.label)
    },
    
    onDonutSelect({selectedIndices, toggledIndex, toggledItem, isSelected}) {
      // Update the unified selection array
      this.selectedTicklistItems = selectedIndices;
      console.log('Donut selection updated:', selectedIndices);
    },
    
    onTicklistChange({selected, capabilities}) {
      this.selectedTicklistItems = selected;
      console.log('Ticklist selection updated:', selected);
    },

    goToSearch(skip = false) {
      if (!skip) {
        localStorage.setItem("selectedResource", this.selectedResource);
        localStorage.setItem("selectedCapabilities", JSON.stringify(this.selectedTicklistItems));
      }
      this.$router.push({ name: "Search" });
    },

    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.reload();
    },

    login() {
      this.toggleAuthModal('LOGIN');
    },
    
    loadGeniallyScript() {
      // Check if script is already loaded
      if (document.getElementById('genially-embed-js')) {
        return;
      }
      
      // Create and append script
      const script = document.createElement('script');
      script.id = 'genially-embed-js';
      script.async = true;
      script.src = 'https://view.genially.com/static/embed/embed.js';
      
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  },

  mounted() {
    // Load existing data from localStorage
    if (JSON.parse(localStorage.getItem('selectedCapabilities'))) {
      this.selectedTicklistItems = JSON.parse(localStorage.getItem('selectedCapabilities'));
    }

    if (parseInt(localStorage.getItem("selectedResource")) > -1) {
      this.selectedResource = parseInt(
        localStorage.getItem("selectedResource")
      );
      this.selectedCapabilities = JSON.parse(localStorage.getItem('selectedCapabilities'));
      this.selectedTicklistItems = JSON.parse(localStorage.getItem('selectedCapabilities'));
    }
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab;
    }
    
    // Load Genially embed script
    this.loadGeniallyScript();
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 369px;
  max-height: 70px;
  width: 100%;
  height: auto;
}

.login-image {
  background-image: url("../../assets/image1.png");
  background-position-x: center;
}

.statement {
  font-size: 17px;
}

.tab-title {
  font-size: 24px;
}

.link {
  text-decoration: underline;
}

.text {
  font-size: 19px;
}

.subtext {
  font-size: 14px;
}

.selected-count {
  font-size: 17px;
  font-weight: bold;
}

.v-list-item {
  max-width: 400px;
  height: 115px;
  align-items: flex-start;
  background-color: #8a8b89;
  margin-bottom: 7px;
  padding-left: 12px;
  .v-list-item__avatar {
    margin-right: 12px;
    border-radius: 50%;
    background-color: #f3b439;
  }

  .v-list-item__content {
    color: white;
  }

  &--active {
    background-color: #f3b439;
    .v-list-item__avatar {
      background-color: #966f23;
      span {
        color: black !important;
      }
    }
  }
}

.v-list-item__content {
  align-self: flex-start;
}

.left-panel {
  background:#009FE3; //#fdbb2a;
  position: relative;

  div {
    background: url("../../assets/IPEPA_Artwork_White_RGB.png");
    background-size: 900px 900px;
    background-position: -400px -100px;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
    opacity: 0.6;
  }
}

@media (min-width: 960px) {
  .login-image {
    height: 600px;
  }
}

.view-toggle {
  display: flex;
  justify-content: center;
  
  .v-btn-toggle {
    background-color: #f5f5f5;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .v-btn {
    text-transform: none;
    font-weight: 600;
  }
}
</style>
